module.exports = __webpack_public_path__ + "media/images/soar/comments_wifi-033947ea3b58a957861c4a5f55726df3.png";